import modalTable from './modalTable.vue'
export default modalTable
